import { DeliveryMethodEnum } from '../../../../../../../types/enums';

export const splitPhoneNumber = (phoneNumber: string | null | undefined) => {
    const raw = String(phoneNumber ?? '').trim();
    const parts = raw.split(/\s+/).filter(Boolean);
    if (parts.length <= 1) {
        return { phoneAreaCode: '', phoneNumber: raw };
    }
    return {
        phoneAreaCode: parts[0] ?? '',
        phoneNumber: parts.slice(1).join(' '),
    };
};

export const getSelectedCountryCode = () => {
    try {
        return JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.countryCode;
    } catch {
        return undefined;
    }
};

export const buildUpdateCustomerAddressInit = (detail: any) => {
    const { phoneAreaCode, phoneNumber } = splitPhoneNumber(detail?.phoneNumber);
    return {
        ...detail,
        phoneAreaCode,
        phoneNumber,
        addressDefinition: detail?.addressDefinition ?? detail?.externalAddressDefinition ?? '',
    };
};

export const ADDRESS_TYPE_SHIPPING = 1;
export const ADDRESS_TYPE_BILLING = 3;

export const buildUpdateCustomerAddressPayload = (
    address: any,
    deliveryMethodId: number | null,
    addressType: number
) => {
    const isPickPointOrStorePickup =
        Number(deliveryMethodId) === DeliveryMethodEnum.PickPoint ||
        Number(deliveryMethodId) === DeliveryMethodEnum.StorePickup;

    const resolvedAddressDefinition = isPickPointOrStorePickup
        ? (address.externalAddressDefinition ?? address.addressDefinition ?? '')
        : (address.addressDefinition ?? address.externalAddressDefinition ?? '');
    const payload: any = {
        ...address,
        addressType,
        deliveryMethod: Number(deliveryMethodId),
        countryCode: address.countryCode ?? getSelectedCountryCode(),
        phoneAreaCode: address.phoneAreaCode,
        phoneNumber: address.phoneNumber,
        addressDefinition: resolvedAddressDefinition,
        sendEmail: true,
    };

    if (Number(deliveryMethodId) === DeliveryMethodEnum.StorePickup) {
        payload.cityId = address.cityId;
        payload.countyId = address.countyId;
    }

    return payload;
};
